import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NetworkSyncService } from '../../services/network-sync.service';
import { SyncOperation } from '../../services/local-database.service';

interface GroupedOps {
  label: string;
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  ops: SyncOperation[];
  columns: string[];
}

@Component({
  selector: 'app-sync-queue-modal',
  templateUrl: './sync-queue-modal.component.html',
  standalone: true,
  imports: [],
})
export class SyncQueueModalComponent implements OnInit {
  groups: GroupedOps[] = [];

  private readonly METHOD_ORDER: Array<'POST' | 'PUT' | 'PATCH' | 'DELETE'> = [
    'POST', 'PUT', 'PATCH', 'DELETE',
  ];

  private readonly METHOD_LABELS: Record<string, string> = {
    POST:   'Creates (POST)',
    PUT:    'Updates (PUT)',
    PATCH:  'Updates (PATCH)',
    DELETE: 'Deletes (DELETE)',
  };

  constructor(
    public modalRef: BsModalRef,
    public networkSync: NetworkSyncService,
  ) {}

  ngOnInit(): void {
    const ops = this.networkSync.pendingOps$.value;
    this.groups = this.METHOD_ORDER
      .map(method => {
        const methodOps = ops.filter(op => op.method === method);
        return {
          label: this.METHOD_LABELS[method],
          method,
          ops: methodOps,
          columns: this.extractColumns(methodOps),
        };
      })
      .filter(g => g.ops.length > 0);
  }

  private extractColumns(ops: SyncOperation[]): string[] {
    const seen = new Set<string>();
    for (const op of ops) {
      if (op.payload && typeof op.payload === 'object') {
        for (const key of Object.keys(op.payload)) {
          seen.add(key);
        }
      }
    }
    return Array.from(seen);
  }

  getCell(op: SyncOperation, key: string): string {
    if (!op.payload) return '�';
    const val = op.payload[key];
    if (val === null || val === undefined || val === '') return '�';
    return typeof val === 'object' ? JSON.stringify(val) : String(val);
  }

  resourceLabel(url: string): string {
    const match = url.match(/\/api\/([^/?]+)/);
    if (!match) return url;
    return match[1]
      .replace(/_/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  formatUrl(url: string): string {
    const match = url.match(/\/api\/(.*)/);
    return match ? match[1] : url;
  }

  methodColor(method: string): string {
    const map: Record<string, string> = {
      POST:   '#4ade80',
      PUT:    '#60a5fa',
      PATCH:  '#facc15',
      DELETE: '#f87171',
    };
    return map[method] ?? '#e0e0e0';
  }

  formatTime(ts: number): string {
    return new Date(ts).toLocaleTimeString();
  }

  formatDate(ts: number): string {
    return new Date(ts).toLocaleDateString();
  }
}
